var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 0.72 0.72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.584 0.167c-0.021 -0.022 -0.058 -0.024 -0.083 0.001l-0.243 0.243c-0.006 0.006 -0.006 0.014 0 0.021s0.014 0.006 0.021 0l0.201 -0.201a0.03 0.03 0 0 1 0.042 0.042l-0.201 0.201a0.073 0.073 0 0 1 -0.105 0 0.073 0.073 0 0 1 0 -0.105l0.243 -0.243c0.047 -0.047 0.123 -0.049 0.169 0 0.047 0.047 0.048 0.123 -0.001 0.168l-0.285 0.285c-0.066 0.066 -0.169 0.066 -0.234 0s-0.066 -0.169 0 -0.234l0.243 -0.243a0.03 0.03 0 0 1 0.042 0.042l-0.243 0.243c-0.042 0.042 -0.042 0.107 0 0.15s0.107 0.042 0.15 0l0.285 -0.285 0.001 -0.001c0.022 -0.021 0.024 -0.058 -0.001 -0.083z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAttachmentIcon);
export default __webpack_public_path__ + "static/media/pin-attachment-icon.43bc2220c8669a09ac4ae33c2b1f1140.svg";
export { ForwardRef as ReactComponent };